import { Pipe, PipeTransform } from "@angular/core";
import { ApplicationService } from "../services/application.service";
import _ from "lodash";

@Pipe({
  name: "translatei18n",
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private appService: ApplicationService) { }
  transform(key: string, fatherKeyTraslate?: string): string {
    return _.get(this.appService.dictionary,key) ?? key;
    // return this.appService.dictionary[key] ?? key;
  }
}
